/*
epidotte_custom BUCKS Currency integration for Horizon.
*/
(() => {
    let raf = null;

    function refreshCurrency() {
        if (!window.bucksCC?.reConvert) return;

        // Prevent multiple refreshes in the same frame
        if (raf) return;

        raf = requestAnimationFrame(() => {
            raf = null;
            window.bucksCC.reConvert();
        });
    }

    // Horizon storefront events
    [
        'shopify:product:select',
        'shopify:collection:update',
        'shopify:search:update',
        'shopify:cart:lines-update'
    ].forEach(type => {
        document.addEventListener(type, async (event) => {
            try {
                await event.promise;
            } catch {
                return;
            }

            refreshCurrency();
        });
    });

    // Quick Add modal
    const attachQuickAddListener = () => {
        const dialog = document.querySelector('#quick-add-dialog dialog');
        if (!dialog || dialog.dataset.bucksListenerAttached) return;

        dialog.dataset.bucksListenerAttached = 'true';

        dialog.addEventListener('animationstart', refreshCurrency);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachQuickAddListener);
    } else {
        attachQuickAddListener();
    }

    // Product Recommendations
    const recommendations = document.querySelector('product-recommendations');

    if (recommendations) {
        new MutationObserver(() => {
            refreshCurrency();
        }).observe(recommendations, {
            childList: true,
            subtree: true
        });
    }

})();
